import React, { useMemo } from 'react';

import {Stack} from "@mui/material";
import {READY_REPORTS_NAVIGATE} from "@containers/reports/readyReports/navigateReadyReports/constants";
import NavigateReadyReportsItem from './item/NavigateReadyReportsItem'
import {sx} from './sx'
import {useLocation} from 'react-router-dom';
import {useGetUserAccessWidthState} from "@containers/account/access/hooks/useGetUserAccess";
import {PATH_REPORT_ICCIDS} from "@constants/navigate";


const NavigateReadyReports = () => {
	
	const location = useLocation();
	
	const {
		access
	} = useGetUserAccessWidthState({
		keys: [
			'ROLE_SUPER_TENANT',
		]
	})
	
	const navigation = useMemo(()=>{
		if(!access){
			return READY_REPORTS_NAVIGATE
		}
		return  [
			...READY_REPORTS_NAVIGATE,
			{
				label: 'reportLabels.reportIccids',
				path: PATH_REPORT_ICCIDS,
			},
		]
	},[access])
	
	const list = navigation.map((item) => {
		const active = location.pathname === item.path;
		
		return (
			<NavigateReadyReportsItem
				{...item}
				active={active}
				key={item.path}
			/>
		)
	})
	
	return (
		<Stack
			sx={sx.root}
			gap={1}
		>
			{list}
		</Stack>
	);
};

export default NavigateReadyReports;